export default class CustomerNote {
  fields = {
    id: {
      value: null
    },
    payor_id: {
      value: null
    },
    text: {
      value: null
    },
    created_by: {
      value: null
    },
    created_at: {
      value: null
    },
    updated_at: {
      value: null
    }
  }

  static createFromQueryValues(values) {
    const customerNote = new this();

    for (let field in customerNote.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          case 'created_at':
          case 'updated_at':
            customerNote.fields[field].value = (values[field] === null) ?
              values[field] :
              new Date(Number(values[field]));
            break;
          default:
            customerNote.fields[field].value = values[field];
        }
      }
    }

    return customerNote;
  }
}
